import axios, { AxiosProgressEvent, AxiosRequestConfig } from "axios";
import { ParseResult } from "papaparse";
import { ChangeEvent, Component } from "react";
import AttachmentTypeEnum from "../../../../models/AttachmentTypeEnum";
import ICreateFileUploadDTO from "../../../../models/DTO/ICreateFileUploadDTO";
import IErrorDTO from "../../../../models/DTO/IErrorDTO";
import IGetCatalogsDTO from "../../../../models/DTO/IGetCatalogsDTO";
import IGetSignedUrlDTO from "../../../../models/DTO/IGetSignedUrlDTO";
import IOnCreateFileUploadDTO from "../../../../models/DTO/IOnCreateFileUploadDTO";
import IOnGetCatalogsDTO from "../../../../models/DTO/IOnGetCatalogsDTO";
import IOnGetSignedUrlDTO from "../../../../models/DTO/IOnGetSignedUrlDTO";
import IOnPerformCatalogCSVCategoryUpdate from "../../../../models/DTO/IOnPerformCatalogCSVCategoryUpdate";
import IOnPerformCatalogCSVInventoryUpdateDTO from "../../../../models/DTO/IOnPerformCatalogCSVInventoryUpdateDTO";
import IOnPerformCatalogCSVItemTemplateUpdateDTO from "../../../../models/DTO/IOnPerformCatalogCSVItemTemplateUpdateDTO";
import IOnPerformCatalogCSVLargeItemTemplateUpdateDTO from "../../../../models/DTO/IOnPerformCatalogCSVLargeItemTemplateUpdateDTO";
import IOnPerformCatalogCSVPriceGroupUpdateDTO from "../../../../models/DTO/IOnPerformCatalogCSVPriceGroupUpdateDTO";
import IOnPerformCatalogCSVPriceUpdateDTO from "../../../../models/DTO/IOnPerformCatalogCSVPriceUpdateDTO";
import IPerformCatalogCSVCategoryUpdateDTO from "../../../../models/DTO/IPerformCatalogCSVCategoryUpdateDTO";
import IPerformCatalogCSVInventoryUpdateDTO from "../../../../models/DTO/IPerformCatalogCSVInventoryUpdateDTO";
import IPerformCatalogCSVItemTemplateUpdateDTO from "../../../../models/DTO/IPerformCatalogCSVItemTemplateUpdateDTO";
import IPerformCatalogCSVPriceGroupUpdateDTO from "../../../../models/DTO/IPerformCatalogCSVPriceGroupUpdateDTO";
import IPerformCatalogCSVPriceUpdateDTO from "../../../../models/DTO/IPerformCatalogCSVPriceUpdateDTO";
import EndpointsEnum from "../../../../models/EndpointsEnum";
import FileUploadResourceTypeEnum from "../../../../models/FileUploadResourceTypeEnum";
import ICatalog from "../../../../models/ICatalog";
import ICatalogCSVCategoryDataRow from "../../../../models/ICatalogCSVCategoryDataRow";
import ICatalogCSVInventoryDataRow from "../../../../models/ICatalogCSVInventoryDataRow";
import ICatalogCSVPriceGroupDataRow from "../../../../models/ICatalogCSVPriceGroupDataRow";
import ICatalogCSVPriceUpdateDataRow from "../../../../models/ICatalogCSVPriceUpdateDataRow";
import ICatalogItemTemplateRow from "../../../../models/ICatalogItemTemplateRow";
import INotification from "../../../../models/INotification";
import InventoryActionEnum from "../../../../models/InventoryActionEnum";
import InventoryUpdateReferenceColEnum from "../../../../models/InventoryUpdateReferenceColEnum";
import IOwRadioSelectOption from "../../../../models/IOwRadioSelectOption";
import IPrice_Group from "../../../../models/IPrice_Group";
import ISupplierModel from "../../../../models/ISupplierModel";
import IUserUI from "../../../../models/IUserUI";
import NotificationLevelEnum from "../../../../models/NotificationLevelEnum";
import NotificationPositionEnum from "../../../../models/NotificationPositionEnum";
import OwButton from "../../../shared/OwButton/OwButton";
import OwCheckbox from "../../../shared/OwCheckbox/OwCheckbox";
import OwCsvReader from "../../../shared/OwCsvReader/OwCsvReader";
import { OwFileUploader } from "../../../shared/OwFileUploader/OwFileUploader";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import OwProgressBar from "../../../shared/OwProgressBar/OwProgressBar";
import OwS3Uploader from "../../../shared/OwS3Uploader/OwS3Uploader";
import OwSelectOption from "../../../shared/OwSelectOption/OwSelectOption";
import OwTitle from "../../../shared/OwTitle/OwTitle";
import OwToggle from "../../../shared/OwToggle/OwToggle";
import WhatsThis from "../../../shared/WhatsThis/WhatsThis";
import "./CatalogUploadUpdateModal.scss";
import { Socket } from "socket.io-client";
import { OwFnInput } from "@components/shared/OwFnInput/OwFnInput";
import IUiSocketSetup from "@models/IUiSocketSetup";

enum UploadTypeEnum {
    CATALOG_ITEM_UPDATE = "catalog_item_update",
    PRICE_GROUP_UPDATE = "price_group_update",
    CATEGORY_UPDATE = "category_update",
    INVENTORY_UPDATE = "inventory_update",
    PRICE_UPDATE = "price_update",
    BULK_IMAGES = "bulk_images",
    CHILD_ITEM_TEMPLATE = "child_item_update",
    ITEM_CATEGORIES = "item_categories",
    PRICE_BAND_UPDATE = "price_band_update",
    PRICE_BANDS_BULK_APPLY = "price_bands_bulk_apply",
    BULK_ITEM_OPTIONS = "bulk_item_options",
    CATALOG_ATTRIBUTES = "catalog_attributes",
    KIT_BUILDER_UPDATE = "kit_builder_update",
    ITEM_OPTIONS_BULK_ASSIGN = "item_options_bulk_assign",
    ITEM_IMAGE_URLS = "item_image_urls_csv",
}

type Props = {
    closeModalFn: () => void;
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    catalogModel?: ICatalog;
    isInventoryOnly?: boolean;
};

type State = {
    typeOptions: { title: string; value: string }[];
    actionItems: { title: string; value: InventoryActionEnum }[];
    selectedAction: InventoryActionEnum;
    fileDropRejected: boolean;
    fileTypeRejected: boolean;
    file?: any;
    contentType?: string;
    isProcessing: boolean;
    upload_type?: UploadTypeEnum;
    uploadActive: boolean;
    csvData?: ParseResult<any>;
    isFormValid: boolean;
    catalogModel?: ICatalog;
    catalogs: ICatalog[];
    referenceColumn: InventoryUpdateReferenceColEnum;
    showResults: boolean;
    recordsUpdated: number;
    recordsCreated: number;
    recordsNotUpdated: number;
    recordsErrored: number;
    totalRecords: number;
    performInactiveCheck: boolean;
    bulkImageFile: any;
    progressTotal: number;
    progressChunk: number;
    progressPerc: number;
    numPriceGroups: number;
    showBulkUploader: boolean;
    resourceType?: FileUploadResourceTypeEnum;
    note: string;
    downloadingTemplate: boolean;
    clearExistingForPriceGroups: boolean;
};

class CatalogUploadUpdateModal extends Component<Props, State> {
    sockets: IUiSocketSetup[] = [];

    constructor(props: any) {
        super(props);

        let typeOptions = [
            {
                value: UploadTypeEnum.PRICE_UPDATE,
                title: "Price List CSV",
            },
            {
                value: UploadTypeEnum.INVENTORY_UPDATE,
                title: "Inventory CSV",
            },
            {
                value: UploadTypeEnum.PRICE_GROUP_UPDATE,
                title: "Price Groups CSV",
            },
            {
                value: UploadTypeEnum.CATEGORY_UPDATE,
                title: "Categories CSV",
            },
            {
                value: UploadTypeEnum.CATALOG_ATTRIBUTES,
                title: "Catalog Attributes CSV",
            },
            {
                value: UploadTypeEnum.CATALOG_ITEM_UPDATE,
                title: "Item Template CSV",
            },
        ];

        if (this.props.supplierModel.has_price_bands) {
            typeOptions.push({
                value: UploadTypeEnum.PRICE_BAND_UPDATE,
                title: "Price Bands CSV",
            });

            typeOptions.push({
                value: UploadTypeEnum.PRICE_BANDS_BULK_APPLY,
                title: "Price Bands Bulk Apply CSV",
            });
        }

        if (this.props.supplierModel.allow_multiple_categories) {
            typeOptions.push({
                value: UploadTypeEnum.ITEM_CATEGORIES,
                title: "Item Categories CSV",
            });
        }

        if (this.props.supplierModel.has_child_items) {
            typeOptions.push({
                value: UploadTypeEnum.CHILD_ITEM_TEMPLATE,
                title: "Child Item CSV",
            });
        }

        typeOptions.push({
            value: UploadTypeEnum.BULK_ITEM_OPTIONS,
            title: "Bulk Item Options CSV",
        });

        typeOptions.push({
            value: UploadTypeEnum.KIT_BUILDER_UPDATE,
            title: "Kit Builder CSV",
        });

        if (this.props.isInventoryOnly) {
            typeOptions = [
                {
                    value: UploadTypeEnum.INVENTORY_UPDATE,
                    title: "Inventory CSV",
                },
            ];
        } else {
            typeOptions.push({
                value: UploadTypeEnum.BULK_IMAGES,
                title: "Bulk Images",
            });

            typeOptions.push({
                value: UploadTypeEnum.ITEM_IMAGE_URLS,
                title: "Item Image URLs CSV",
            });
        }

        typeOptions.push({
            value: UploadTypeEnum.ITEM_OPTIONS_BULK_ASSIGN,
            title: "Item Options Bulk Assign CSV",
        });

        this.state = {
            typeOptions,
            actionItems: [
                { title: "Add", value: InventoryActionEnum.ADD },
                { title: "Subtract", value: InventoryActionEnum.SUBTRACT },
                { title: "Replace", value: InventoryActionEnum.REPLACE },
            ],
            selectedAction: InventoryActionEnum.ADD,
            fileDropRejected: false,
            fileTypeRejected: false,
            isProcessing: false,
            uploadActive: false,
            isFormValid: false,
            catalogModel: this.props.catalogModel,
            catalogs: [],
            referenceColumn: InventoryUpdateReferenceColEnum.SKU,
            showResults: false,
            totalRecords: 0,
            recordsUpdated: 0,
            recordsCreated: 0,
            recordsNotUpdated: 0,
            recordsErrored: 0,
            performInactiveCheck: this.props.supplierModel.has_auto_inactive_bulk_load,
            bulkImageFile: null,
            progressTotal: 0,
            progressChunk: 0,
            progressPerc: 0,
            numPriceGroups: this.props.catalogModel?.Price_Groups?.length || 0,
            showBulkUploader: false,
            note: "",
            downloadingTemplate: false,
            clearExistingForPriceGroups: false,
        };

        this.sockets = [
            { endpoint: EndpointsEnum.CatalogsOnPerformCatalogCSVInventoryUpdate, fn: this.onPerformCatalogCSVInventoryUpdate },
            { endpoint: EndpointsEnum.CatalogsOnPerformCatalogCSVPriceUpdate, fn: this.onPerformCatalogCSVPriceUpdate },
            { endpoint: EndpointsEnum.CatalogsOnPerformCatalogCSVItemTemplateUpdate, fn: this.onPerformCatalogCSVItemTemplateUpdate },
            { endpoint: EndpointsEnum.CatalogsOnPerformCatalogCSVCategoryUpdate, fn: this.onPerformCatalogCSVCategoryUpdate },
            { endpoint: EndpointsEnum.CatalogsOnPerformCatalogCSVPriceGroupUpdate, fn: this.onPerformCatalogCSVPriceGroupUpdate },
            { endpoint: EndpointsEnum.Notify, fn: this.notify },
            { endpoint: EndpointsEnum.CatalogsOnGetCatalogs, fn: this.onGetCatalogs },
            { endpoint: EndpointsEnum.FileUploadOnGetSignedUrl, fn: this.onGetSignedUrl },
            { endpoint: EndpointsEnum.FileUploadOnCreateFileUpload, fn: this.onCreateFileUpload },
            {
                endpoint: EndpointsEnum.CatalogsOnPerformCatalogCSVLargeItemTemplateUpdate,
                fn: this.onPerformCatalogCSVLargeItemTemplateUpdate,
            },
        ];
    }

    componentDidMount(): void {
        for (const socket of this.sockets) {
            this.props.socket.on(socket.endpoint, socket.fn);
        }

        if (!this.state.catalogModel) {
            this.getCatalogs();
        }
    }

    componentWillUnmount(): void {
        for (const socket of this.sockets) {
            this.props.socket.off(socket.endpoint, socket.fn);
        }
    }

    getCatalogs = () => {
        const payload: IGetCatalogsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            callMeta: {
                view: "CatalogUploadUpdateModal",
                fn: "getCatalogs",
            },
        };

        this.props.socket.emit(EndpointsEnum.CatalogsGetCatalogs, payload);
    };

    onGetCatalogs = (data: IOnGetCatalogsDTO) => {
        this.setState({
            catalogs: data.catalogs,
        });
    };

    notify = (data: IErrorDTO) => {
        this.setState({
            uploadActive: false,
        });
    };

    /**
     * This is currently only used for bulk images.
     */
    getSignedUrl = () => {
        const payload: IGetSignedUrlDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            file: {
                name: this.state.bulkImageFile.name,
                type: this.state.bulkImageFile.type,
            },
            resourceType: FileUploadResourceTypeEnum.bulkImages,
        };

        this.props.socket.emit(EndpointsEnum.FileUploadGetSignedUrl, payload);
    };

    onGetSignedUrl = async (data: IOnGetSignedUrlDTO) => {
        if (this.state.bulkImageFile) {
            console.log("Start Upload");

            const config: AxiosRequestConfig = {
                headers: {
                    "Content-Type": this.state.bulkImageFile.type,
                },
                onUploadProgress: (progressEvent: AxiosProgressEvent) => {
                    console.log(progressEvent);
                    if (progressEvent.total) {
                        // this.onUploadProgress(progressEvent);
                        const progressPerc = (progressEvent.loaded / progressEvent.total) * 100;

                        const progressTotal = Number((progressEvent.total / 1048576).toFixed(2));

                        const progressChunk = Number((progressEvent.loaded / 1048576).toFixed(2));

                        this.setState({
                            progressTotal,
                            progressChunk,
                            progressPerc,
                        });
                    }
                },
            };

            const res = await axios.put(data.signedUrl, this.state.bulkImageFile, config);

            console.log("End Upload. ", res);

            const createFileUploadData: ICreateFileUploadDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                name: data.name,
                url: data.url,
                bucket: data.bucket,
                key: data.key,
                eTag: res.headers.etag,
                size: this.state.bulkImageFile.size,
                attachment_type_id: AttachmentTypeEnum.zip,
                catalogGuid: this.props.catalogModel!.guid,
                fileUploadResourceTypeId: FileUploadResourceTypeEnum.bulkImages,
            };

            this.createFileUpload(createFileUploadData);
        }
    };

    createFileUpload = (data: ICreateFileUploadDTO) => {
        this.props.socket.emit(EndpointsEnum.FileUploadCreateFileUpload, data);
    };

    onCreateFileUpload = (data: IOnCreateFileUploadDTO) => {
        this.setState({
            uploadActive: false,
        });
    };

    onPerformCatalogCSVInventoryUpdate = (data: IOnPerformCatalogCSVInventoryUpdateDTO) => {
        const notification: INotification = {
            message: "successfully_updated_catalog_inventory",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.br,
        };

        this.props.notifyFn(null, notification);

        this.setState({
            uploadActive: false,
            showResults: true,
            totalRecords: data.totalRecords,
            recordsUpdated: data.recordsUpdated,
        });
    };

    onPerformCatalogCSVCategoryUpdate = (data: IOnPerformCatalogCSVCategoryUpdate) => {
        const notification: INotification = {
            message: "successfully_updated_catalog_categories",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.br,
        };

        this.props.notifyFn(null, notification);

        this.setState({
            uploadActive: false,
            showResults: true,
            totalRecords: data.totalRecords,
            recordsUpdated: data.recordsUpdated,
            recordsCreated: data.recordsCreated,
            recordsNotUpdated: data.recordsNotUpdated,
            recordsErrored: data.recordsErrored,
        });
    };

    onPerformCatalogCSVPriceGroupUpdate = (data: IOnPerformCatalogCSVPriceGroupUpdateDTO) => {
        const notification: INotification = {
            message: "successfully_updated_catalog_price_groups",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.br,
        };

        this.props.notifyFn(null, notification);

        this.setState({
            uploadActive: false,
            showResults: true,
            totalRecords: data.totalRecords,
            recordsUpdated: data.recordsUpdated,
            recordsCreated: data.recordsCreated,
            recordsNotUpdated: data.recordsNotUpdated,
            recordsErrored: data.recordsErrored,
        });
    };

    onPerformCatalogCSVPriceUpdate = (data: IOnPerformCatalogCSVPriceUpdateDTO) => {
        const notification: INotification = {
            message: "successfully_updated_catalog_pricing",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.br,
        };

        this.props.notifyFn(null, notification);

        this.setState({
            uploadActive: false,
            showResults: true,
            totalRecords: data.totalRecords,
            recordsUpdated: data.recordsUpdated,
        });
    };

    onPerformCatalogCSVItemTemplateUpdate = (data: IOnPerformCatalogCSVItemTemplateUpdateDTO) => {
        const notification: INotification = {
            message: "successfully_updated_catalog_items",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.br,
        };

        this.props.notifyFn(null, notification);

        this.setState({
            uploadActive: false,
            showResults: true,
            totalRecords: data.totalRecords,
            recordsUpdated: data.recordsUpdated,
            recordsCreated: data.recordsCreated,
            recordsNotUpdated: data.recordsNotUpdated,
        });
    };

    onPerformCatalogCSVLargeItemTemplateUpdate = (data: IOnPerformCatalogCSVLargeItemTemplateUpdateDTO) => {
        alert("Finished the Large Item Template Update.");
    };

    closeModal = () => {
        this.props.closeModalFn();
    };

    toggleClearExistingForPriceGroups = () => {
        this.setState({ clearExistingForPriceGroups: !this.state.clearExistingForPriceGroups });
    };

    handleChange = (e: any) => {
        const name = e.target.name;
        const value = e.target.value;

        const state: any = {
            [name]: value,
        };

        this.setState(state, () => {
            this.isFormValid();
            this.getS3UploadType();
        });
    };

    doUpload = () => {
        this.setState(
            {
                uploadActive: true,
            },
            () => {
                this.processUploadType();
            }
        );
    };

    setupCategoryCSVData = (csvData: ParseResult<any>) => {
        if (!this.state.catalogModel) {
            return null;
        }

        const catalogCol = "Catalog";
        const rootCategoryCol = "Root Category";
        const categoryLevelOneCol = "Category Level One";
        const categoryLevelTwoCol = "Category Level Two";
        const categoryLevelThreeCol = "Category Level Three";
        let categoryGuidCol = "Category Guid";
        const discountCol = "Discount";
        const categoryOrderCol = "Category Order";

        const firstRow: object = csvData.data[0];

        const priceGroups: IPrice_Group[] = this.state.catalogModel.Price_Groups || [];
        const priceGroupCols: any = {};

        for (const col of Object.keys(firstRow)) {
            if (col.toLowerCase().indexOf("category guid") >= 0) {
                categoryGuidCol = col;
            }

            for (const priceGroup of priceGroups) {
                if (col.toLowerCase().indexOf(priceGroup.value.toLowerCase()) >= 0) {
                    priceGroupCols[priceGroup.value] = col; // col.substr(0, priceGroup.value.length);
                }
            }
        }

        const items: ICatalogCSVCategoryDataRow[] = [];

        for (const row of csvData.data) {
            console.log("rowData", row);

            const data: ICatalogCSVCategoryDataRow = {
                catalog: row[catalogCol],
                rootCategory: row[rootCategoryCol],
                categoryLevelOne: row[categoryLevelOneCol],
                categoryLevelTwo: row[categoryLevelTwoCol],
                categoryLevelThree: row[categoryLevelThreeCol],
                categoryGuid: row[categoryGuidCol],
                categoryOrder: row[categoryOrderCol],
            };

            if (this.props.supplierModel.has_discounts) {
                data.discount = row[discountCol];
            }

            if (this.props.supplierModel.has_price_group_category_discounts) {
                for (const priceGroupCol of Object.keys(priceGroupCols)) {
                    const priceGroup: any = priceGroupCols[priceGroupCol];

                    const colMatch = priceGroup.match(/(\w+) \(Discount\)/);
                    console.log(`colMatch: `, colMatch);
                    const colProp = colMatch[1];

                    console.log(`colProp: `, colProp);

                    data[`${colProp}`] = row[priceGroup];
                }
            }

            // skips the header row.
            if (data.catalog) {
                items.push(data);
            }
        }

        const payload: IPerformCatalogCSVCategoryUpdateDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            rows: JSON.stringify(items),
            catalogGuid: this.state.catalogModel.guid,
        };

        this.props.socket.emit("performCatalogCSVCategoryUpdate", payload);

        this.resetResults();
    };

    setupInventoryCSVData = (csvData: ParseResult<any>) => {
        let skuCol = "0";
        let descriptionCol = "1";
        let trackInventoryCol = "2";
        let qtyOnHandCol = "3";
        let minQtyOnHandCol = "4";
        let maxQtyOnHandCol = "5";
        let packsCol = "6";
        let itemGuidCol = "7";

        const firstRow: object = csvData.data[0];

        for (const col of Object.keys(firstRow)) {
            if (col.toLowerCase().indexOf("sku") >= 0) {
                skuCol = col;
            }

            if (col.toLowerCase().indexOf("description") >= 0) {
                descriptionCol = col;
            }

            if (col.toLowerCase().indexOf("track inventory") >= 0) {
                trackInventoryCol = col;
            }

            if (col.toLowerCase() === "qty. on hand") {
                qtyOnHandCol = col;
            }

            if (col.toLowerCase() === "minimum qty. on hand") {
                minQtyOnHandCol = col;
            }

            if (col.toLowerCase() === "maximum qty. on hand") {
                maxQtyOnHandCol = col;
            }

            if (col.toLowerCase() === "packs") {
                packsCol = col;
            }

            if (col.toLowerCase().indexOf("item guid") >= 0) {
                itemGuidCol = col;
            }
        }

        const items: ICatalogCSVInventoryDataRow[] = [];

        for (const row of csvData.data) {
            const data: ICatalogCSVInventoryDataRow = {
                sku: row[skuCol],
                description: row[descriptionCol],
                track_inventory: row[trackInventoryCol],
                qty_on_hand: row[qtyOnHandCol],
                min_qty_on_hand: row[minQtyOnHandCol],
                max_qty_on_hand: row[maxQtyOnHandCol],
                packs: row[packsCol],
                item_guid: row[itemGuidCol],
            };

            if (data.sku && data.sku.length) {
                items.push(data);
            }
        }

        const payload: IPerformCatalogCSVInventoryUpdateDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            rows: JSON.stringify(items),
            action: this.state.selectedAction,
            referenceColumn: this.state.referenceColumn,
            catalogGuid: this.state.catalogModel ? this.state.catalogModel.guid : undefined,
            note: this.state.note.length ? this.state.note : undefined,
        };

        this.props.socket.emit("performCatalogCSVInventoryUpdate", payload);

        this.resetResults();
    };

    setupPriceUpdateCSVData = (csvData: ParseResult<any>) => {
        if (!this.state.catalogModel) {
            return null;
        }

        let skuCol = "0";
        let descriptionCol = "1";
        let itemGuidCol = "";

        const priceGroups: IPrice_Group[] = this.state.catalogModel.Price_Groups || [];

        const firstRow: object = csvData.data[0];

        const priceGroupCols: any = {};

        for (const col of Object.keys(firstRow)) {
            if (col.toLowerCase().indexOf("sku") >= 0) {
                skuCol = col;
            }

            if (col.toLowerCase().indexOf("description") >= 0) {
                descriptionCol = col;
            }

            if (col.toLowerCase().indexOf("item guid (do not edit)") >= 0) {
                itemGuidCol = col;
            }

            for (const priceGroup of priceGroups) {
                if (col.toLowerCase() === priceGroup.value.toLowerCase()) {
                    priceGroupCols[priceGroup.value] = col;
                }
            }
        }

        const items: ICatalogCSVPriceUpdateDataRow[] = [];

        for (const row of csvData.data) {
            const dataRow = {
                sku: row[skuCol],
                description: row[descriptionCol],
                item_guid: row[itemGuidCol],
            };

            for (const priceGroupCol of Object.keys(priceGroupCols)) {
                const priceGroup: any = priceGroupCols[priceGroupCol];

                // @ts-expect-error
                dataRow[`${priceGroup}`] = row[priceGroup];
            }

            if (dataRow.sku && dataRow.sku.length) {
                items.push(dataRow);
            }
        }

        const payload: IPerformCatalogCSVPriceUpdateDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            catalogGuid: this.state.catalogModel.guid,
            rows: JSON.stringify(items),
        };

        this.props.socket.emit("performCatalogCSVPriceUpdate", payload);
        // console.log('IPerformCatalogCSVPriceUpdateDTO', payload);
        this.resetResults();
    };

    setupCatalogItemUpdateCSVData = (csvData: ParseResult<any>) => {
        if (!this.state.catalogModel) {
            return null;
        }

        const catalogCol = "Catalog";
        const nameCol = "Name";
        const skuCol = "SKU";
        const upcCol = "UPC";
        const descriptionCol = "Description";
        const rootCategoryCol = "Root Category";
        const categoryLevelOneCol = "Category Level One";
        const categoryLevelTwoCol = "Category Level Two";
        const categoryLevelThreeCol = "Category Level Three";
        const uomCol = "UoM";
        const activeCol = "Active";
        const hasInventoryCol = "Has Inventory";
        const hasAlternateSourcingCol = "Has Alternate Sourcing";
        const isAlternateSourceCol = "Is Alternate Source";
        const isCustomerOrderableCol = "Is Customer Orderable";
        const qtyOnHandCol = "Qty. on Hand";
        const minQtyOnHandCol = "Min. Qty. on Hand";
        const maxQtyOnHandCol = "Max. Qty. on Hand";
        const maxOrderQtyCol = "Max Order Qty.";
        const minOrderQtyCol = "Min. Order Qty.";
        const packsCol = "Packs";
        const hasPackQtyCol = "Has Pack Qty.";
        const packQtyCol = "Pack Qty.";
        const pricePerPackCol = "Price Per Pack";
        const unitIncrQtyCol = "Unit Incr. Qty.";
        const allowBackorderCol = "Allow Backorder";
        const requireAddlInputCol = "Require Addl. Input";
        const msrpCol = "MSRP";
        const widthCol = "Width";
        const heightCol = "Height";
        // The server template emits "Length" (length_for_depth) or "Depth"; older
        // hand-made files may still use the combined header.
        const depthCol = this.props.supplierModel.length_for_depth ? "Length" : "Depth";
        const legacyDepthCol = "Depth / Length";
        const dimensionUnitCol = "Dimension Unit";
        const pricingFormulaCol = "Pricing Formula";
        const shippingWeightCol = "Shipping Weight";
        const itemWeightCol = "Item Weight";
        let itemGuidCol = "";
        const itemOrderCol = "Item Order";
        const deliveryEtaCol = "Delivery ETA";
        const costCol = "Cost";
        const minPriceCol = "Min. Price";
        const isProductGroupCol = "Is Product Group";
        const productGroupSkuCol = "Product Group Sku";
        const productGroupLabelCol = "Product Group Label";

        const priceGroups: IPrice_Group[] = this.state.catalogModel.Price_Groups || [];

        const firstRow: object = csvData.data[0];

        const priceGroupCols: any = {};

        for (const col of Object.keys(firstRow)) {
            if (col.toLowerCase().indexOf("item guid (blank for new, do not edit)") >= 0) {
                itemGuidCol = col;
            }

            for (const priceGroup of priceGroups) {
                if (col.toLowerCase() === priceGroup.value.toLowerCase()) {
                    priceGroupCols[priceGroup.value] = col;
                }
            }
        }

        // TODO if the price group cols exceeds 20, then push the data file to the server directly and process there without
        // parsing it in the UI, otherwise the UI will lockup and crash.

        if (priceGroups.length > 20) {
            // show the S3 Uploader and do the upload routine.
            // let payload: IPerformCatalogCSVLargeItemTemplateUpdateDTO = {
            //     userGuid: this.props.userModel.guid,
            //     userToken: this.props.userModel.token,
            //     supplierGuid: this.props.supplierModel.guid,
            //     catalogGuid: this.state.catalogModel.guid,
            //     csvData: JSON.stringify(csvData.data),
            // }
            //
            // this.props.socket.emit(EndpointsEnum.CatalogsPerformCatalogCSVLargeItemTemplateUpdate, payload);
        } else {
            const items: ICatalogItemTemplateRow[] = [];

            for (const row of csvData.data) {
                const dataRow: ICatalogItemTemplateRow = {
                    catalog: row[catalogCol],
                    sku: row[skuCol],
                    description: row[descriptionCol],
                    rootCategory: row[rootCategoryCol],
                    categoryLevelOne: row[categoryLevelOneCol],
                    categoryLevelTwo: row[categoryLevelTwoCol],
                    categoryLevelThree: row[categoryLevelThreeCol],
                    itemOrder: row[itemOrderCol],
                    item_guid: row[itemGuidCol],
                    qty_on_hand: row[qtyOnHandCol],
                    min_qty_on_hand: row[minQtyOnHandCol],
                    max_qty_on_hand: row[maxQtyOnHandCol],
                    max_order_qty: row[maxOrderQtyCol],
                    min_order_qty: row[minOrderQtyCol],
                    packs: row[packsCol],
                    has_pack_qty: row[hasPackQtyCol],
                    pack_qty: row[packQtyCol],
                    price_per_pack: row[pricePerPackCol],
                    unit_incr_qty: row[unitIncrQtyCol],
                    has_inventory: row[hasInventoryCol],
                    has_alternate_sourcing: row[hasAlternateSourcingCol],
                    is_alternate_source: row[isAlternateSourceCol],
                    is_customer_orderable: row[isCustomerOrderableCol],
                    allow_backorder: row[allowBackorderCol],
                    require_addl_input: row[requireAddlInputCol],
                    active: row[activeCol],
                    unit_of_measurement: row[uomCol],
                    upc: row[upcCol],
                    msrp: row[msrpCol],
                    name: row[nameCol],
                    shipping_weight: row[shippingWeightCol],
                    item_weight: row[itemWeightCol],
                    is_product_group: row[isProductGroupCol],
                    product_group_sku: row[productGroupSkuCol],
                    product_group_label: row[productGroupLabelCol],
                };

                if (this.props.supplierModel.has_cost_pricing) {
                    dataRow.cost_per_uom = row[costCol];
                }

                if (this.props.supplierModel.below_min_price_approval) {
                    dataRow.min_price = row[minPriceCol];
                }

                if (this.props.supplierModel.has_catalog_item_delivery_eta) {
                    dataRow.delivery_eta = row[deliveryEtaCol];
                }

                if (this.props.supplierModel.has_dimensions) {
                    dataRow.width = row[widthCol];
                    dataRow.height = row[heightCol];
                    dataRow.depth = row[depthCol] ?? row[legacyDepthCol];
                    dataRow.dimension_unit = row[dimensionUnitCol];
                }

                // Formula NAME (matches Pricing_Formulas.name); the server template round-trips
                // this column unconditionally — absent leaves the item unchanged, blank clears it.
                dataRow.pricing_formula = row[pricingFormulaCol];

                for (const priceGroupCol of Object.keys(priceGroupCols)) {
                    const priceGroup: any = priceGroupCols[priceGroupCol];

                    if (row[priceGroup].length) {
                        // @ts-expect-error
                        dataRow[`${priceGroup}`] = row[priceGroup];
                    }
                }

                // console.log("dataRow", dataRow);

                if (dataRow.sku && dataRow.sku.length) {
                    items.push(dataRow);
                }
            }

            const payload: IPerformCatalogCSVItemTemplateUpdateDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                catalogGuid: this.state.catalogModel.guid,
                rows: JSON.stringify(items),
                performInactiveCheck: this.state.performInactiveCheck,
            };

            this.props.socket.emit(EndpointsEnum.CatalogsPerformCatalogCSVItemTemplateUpdate, payload);
            // console.log('IPerformCatalogCSVPriceUpdateDTO', payload);
            this.resetResults();
        }
    };

    setupPriceGroupUpdateCSVData = (csvData: ParseResult<any>) => {
        if (!this.state.catalogModel) {
            return null;
        }

        const catalogCol = "Catalog";
        const priceGroupCol = "Price Group";
        let priceGroupGuidCol = "";

        const firstRow: object = csvData.data[0];

        for (const col of Object.keys(firstRow)) {
            if (col.toLowerCase().indexOf("price group guid") >= 0) {
                priceGroupGuidCol = col;
            }
        }

        const items: ICatalogCSVPriceGroupDataRow[] = [];

        for (const row of csvData.data) {
            const dataRow: ICatalogCSVPriceGroupDataRow = {
                catalog: row[catalogCol],
                priceGroup: row[priceGroupCol],
                priceGroupGuid: row[priceGroupGuidCol],
            };

            if (dataRow.priceGroup && dataRow.priceGroup.length) {
                items.push(dataRow);
            }
        }

        const payload: IPerformCatalogCSVPriceGroupUpdateDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            catalogGuid: this.state.catalogModel.guid,
            rows: JSON.stringify(items),
        };

        this.props.socket.emit("performCatalogCSVPriceGroupUpdate", payload);
        this.resetResults();
    };

    resetResults = () => {
        this.setState({
            showResults: false,
            recordsUpdated: 0,
            totalRecords: 0,
            recordsCreated: 0,
            recordsNotUpdated: 0,
        });
    };

    processUploadType = () => {
        if (this.state.upload_type && this.state.csvData) {
            switch (this.state.upload_type) {
                case UploadTypeEnum.PRICE_UPDATE:
                    this.setupPriceUpdateCSVData(this.state.csvData);
                    break;

                case UploadTypeEnum.INVENTORY_UPDATE:
                    this.setupInventoryCSVData(this.state.csvData);
                    break;

                case UploadTypeEnum.CATALOG_ITEM_UPDATE:
                    this.setupCatalogItemUpdateCSVData(this.state.csvData);
                    break;

                case UploadTypeEnum.CATEGORY_UPDATE:
                    this.setupCategoryCSVData(this.state.csvData);
                    break;

                case UploadTypeEnum.PRICE_GROUP_UPDATE:
                    this.setupPriceGroupUpdateCSVData(this.state.csvData);
                    break;
            }
        } else if (this.state.upload_type && this.state.upload_type === UploadTypeEnum.BULK_IMAGES) {
            this.getSignedUrl();
        }
    };

    bulkImagesLoaded = (file: any) => {
        // console.log("bulkImagesLoaded", file);

        this.setState({
            bulkImageFile: file,
            isFormValid: true,
        });
    };

    performBulkImageZipUpload = () => {
        // console.log();
    };

    isFormValid = () => {
        let isFormValid = false;

        if (this.state.csvData && this.state.upload_type) {
            isFormValid = true;
        }

        this.setState({
            isFormValid,
        });
    };

    csvLoaded = (csvData?: ParseResult<any>) => {
        if (csvData) {
            this.setState(
                {
                    csvData,
                },
                () => {
                    this.isFormValid();
                }
            );
        }
    };

    getS3UploadType = () => {
        let resourceType = FileUploadResourceTypeEnum.catalogItemTemplateCsv;
        let showBulkUploader = this.state.showBulkUploader;

        switch (this.state.upload_type) {
            case UploadTypeEnum.CATALOG_ITEM_UPDATE:
                resourceType = FileUploadResourceTypeEnum.catalogItemTemplateCsv;
                break;

            case UploadTypeEnum.CHILD_ITEM_TEMPLATE:
                resourceType = FileUploadResourceTypeEnum.childItemTemplateCsv;
                break;

            case UploadTypeEnum.ITEM_CATEGORIES:
                resourceType = FileUploadResourceTypeEnum.catalogItemCategoriesCsv;
                showBulkUploader = true;
                break;

            case UploadTypeEnum.PRICE_BAND_UPDATE:
                resourceType = FileUploadResourceTypeEnum.priceBandsCsv;
                showBulkUploader = true;
                break;

            case UploadTypeEnum.PRICE_BANDS_BULK_APPLY:
                resourceType = FileUploadResourceTypeEnum.priceBandsBulkApplyCsv;
                showBulkUploader = true;
                break;

            case UploadTypeEnum.BULK_ITEM_OPTIONS:
                resourceType = FileUploadResourceTypeEnum.bulkItemOptionsCsv;
                showBulkUploader = true;
                break;

            case UploadTypeEnum.CATALOG_ATTRIBUTES:
                resourceType = FileUploadResourceTypeEnum.catalogAttributesCsv;
                showBulkUploader = true;
                break;

            case UploadTypeEnum.KIT_BUILDER_UPDATE:
                resourceType = FileUploadResourceTypeEnum.bulkKitBuilderCsv;
                showBulkUploader = true;
                break;

            case UploadTypeEnum.ITEM_OPTIONS_BULK_ASSIGN:
                resourceType = FileUploadResourceTypeEnum.itemOptionsAssignCsv;
                showBulkUploader = true;
                break;

            case UploadTypeEnum.PRICE_UPDATE:
                resourceType = FileUploadResourceTypeEnum.priceListCsv;
                showBulkUploader = true;
                break;

            case UploadTypeEnum.ITEM_IMAGE_URLS:
                resourceType = FileUploadResourceTypeEnum.catalogItemImagesUrlCsv;
                showBulkUploader = true;
                break;
        }

        this.setState({
            resourceType,
            showBulkUploader,
        });
    };

    handleUploadTypeChange = (e: ChangeEvent<any>) => {
        const value = e.target.value;

        let showBulkUploader = false;

        if (value === "bulk_uploader") {
            showBulkUploader = true;
        }

        this.setState({
            showBulkUploader,
        });
    };

    render() {
        const uploadOptions: IOwRadioSelectOption[] = [
            {
                label: "Bulk Uploader (More than 100 records)",
                value: "bulk_uploader",
            },
            // {
            //     label: "Basic Uploader",
            //     value: "basic_uploader",
            // },
        ];

        return (
            <div className="CatalogUploadUpdateModal p-2" tabIndex={0}>
                <div className={"w-100"} style={{ height: "2rem" }}>
                    <div className={"d-flex justify-content-between"}>
                        <div className={"d-flex text-truncate me-3"}>
                            <OwTitle leftIconName={"fad fa-cloud-upload-alt"} title={"upload_update"} tag={"h3"} />
                        </div>
                        <div>
                            <OwButton className={"btn-danger"} centerIconClass={"fas fa-times"} fn={this.closeModal} />
                        </div>
                    </div>
                </div>
                {this.props.catalogModel ? (
                    <h3 className={"mt-4"}>{this.props.catalogModel.name}</h3>
                ) : (
                    <div className={"w-100"}>
                        <div></div>
                        <div className={""}>
                            <OwLabel title={"catalog"} noBottomMargin={true} />
                            <OwSelectOption
                                valueProp={"guid"}
                                titleProp={"name"}
                                emitObject={true}
                                options={this.state.catalogs}
                                name={"catalogModel"}
                                fn={this.handleChange}
                                showBlankFirst={true}
                            />
                        </div>
                    </div>
                )}
                <div className={"w-100 mt-4"}>
                    <div className={""}>
                        <OwLabel title={"type"} noBottomMargin={true} />:
                        <OwSelectOption
                            valueProp={"value"}
                            titleProp={"title"}
                            name={"upload_type"}
                            fn={this.handleChange}
                            options={this.state.typeOptions}
                            selectedOption={this.state}
                            selectedOptionProp={"upload_type"}
                            autoSelectSingleOption={true}
                            isDisabled={this.state.showResults}
                            showBlankFirst={true}
                        />
                    </div>

                    {this.state.upload_type === UploadTypeEnum.BULK_IMAGES ? (
                        <div className={"mt-3"}>
                            <a
                                href={"https://learn.orderwerks.com/bulk-image-import"}
                                target={"_blank"}
                                className={"pointer"}
                                rel="noreferrer">
                                <OwLabel
                                    className={"pointer"}
                                    leftIconClass={"fad fa-external-link"}
                                    title={"bulk_image_import_instructions"}
                                />
                            </a>
                        </div>
                    ) : null}

                    {this.state.upload_type === UploadTypeEnum.ITEM_IMAGE_URLS ? (
                        <div className={"mt-3"}>
                            <div>
                                <OwLabel title={"item_image_urls_import_help_slots"} noBottomMargin={true} />
                            </div>
                            <div>
                                <OwLabel title={"item_image_urls_import_help_replace"} noBottomMargin={true} />
                            </div>
                            <div>
                                <OwLabel title={"item_image_urls_import_help_limits"} noBottomMargin={true} />
                            </div>
                            <div>
                                <OwLabel title={"item_image_urls_import_help_matching"} noBottomMargin={true} />
                            </div>
                        </div>
                    ) : null}

                    {this.state.upload_type === UploadTypeEnum.PRICE_BAND_UPDATE ? (
                        <div className={"mt-4"}>
                            <WhatsThis subject={"help_text_replace_existing_price_bands"} />
                            <OwToggle
                                fn={this.toggleClearExistingForPriceGroups}
                                name={"clearExistingForPriceGroups"}
                                label={"replace_existing_price_bands"}
                                active={this.state.clearExistingForPriceGroups}
                            />
                        </div>
                    ) : null}

                    {this.props.isInventoryOnly || this.state.upload_type === "inventory_update" ? (
                        <div className={"mt-4"}>
                            <OwLabel title={"action"} noBottomMargin={true} />
                            <OwSelectOption
                                options={this.state.actionItems}
                                valueProp={"value"}
                                titleProp={"title"}
                                name={"selectedAction"}
                                fn={this.handleChange}
                                selectedOption={this.state}
                                selectedOptionProp={"selectedAction"}
                                showBlankFirst={true}
                            />
                        </div>
                    ) : null}

                    {this.props.isInventoryOnly || this.state.upload_type === "inventory_update" ? (
                        <>
                            <div className={"mt-4"}>
                                <OwLabel title={"reference_column"} noBottomMargin={true} />
                                <div className={"w-15r"}>
                                    <WhatsThis subject={"what_is_reference_column"} />
                                </div>
                                <OwSelectOption
                                    options={[
                                        { title: "Item Guid", value: InventoryUpdateReferenceColEnum.ITEM_GUID },
                                        { title: "SKU", value: InventoryUpdateReferenceColEnum.SKU },
                                    ]}
                                    valueProp={"value"}
                                    titleProp={"title"}
                                    name={"referenceColumn"}
                                    fn={this.handleChange}
                                    selectedOption={this.state}
                                    selectedOptionProp={"referenceColumn"}
                                    showBlankFirst={true}
                                />
                            </div>
                            <div className="mt-4">
                                <OwLabel title={"note"} />
                                <OwFnInput
                                    fn={this.handleChange}
                                    name={"note"}
                                    value={this.state.note}
                                    type={"text"}
                                    placeholder={"note"}
                                />
                            </div>
                        </>
                    ) : null}

                    {this.state.showResults ? null : this.state.upload_type === UploadTypeEnum.BULK_IMAGES ? (
                        <div className={"mt-4"}>
                            <div className={"drop-area"}>
                                <OwFileUploader onFileLoaded={this.bulkImagesLoaded} />
                            </div>
                        </div>
                    ) : null}

                    {this.state.showResults ? null : this.state.upload_type && this.state.upload_type !== UploadTypeEnum.BULK_IMAGES ? (
                        <div className={"mt-4"}>
                            {/*{this.state.numPriceGroups < 10 && this.state.upload_type === UploadTypeEnum.CATALOG_ITEM_UPDATE ? (*/}
                            {/*    <div>*/}
                            {/*        <OwRadioSelect options={uploadOptions} name={"bulk_upload"} fn={this.handleUploadTypeChange} />*/}
                            {/*    </div>*/}
                            {/*) : null}*/}
                            <div className={"drop-area"}>
                                {(this.state.resourceType && this.state.upload_type === UploadTypeEnum.CATALOG_ITEM_UPDATE) ||
                                this.state.upload_type === UploadTypeEnum.CHILD_ITEM_TEMPLATE ||
                                this.state.upload_type === UploadTypeEnum.ITEM_CATEGORIES ||
                                this.state.upload_type === UploadTypeEnum.PRICE_UPDATE ||
                                this.state.upload_type === UploadTypeEnum.BULK_ITEM_OPTIONS ||
                                this.state.upload_type === UploadTypeEnum.PRICE_BAND_UPDATE ||
                                this.state.upload_type === UploadTypeEnum.PRICE_BANDS_BULK_APPLY ||
                                this.state.upload_type === UploadTypeEnum.CATALOG_ATTRIBUTES ||
                                this.state.upload_type === UploadTypeEnum.ITEM_OPTIONS_BULK_ASSIGN ||
                                this.state.upload_type === UploadTypeEnum.KIT_BUILDER_UPDATE ||
                                (this.state.upload_type === UploadTypeEnum.ITEM_IMAGE_URLS && this.state.catalogModel?.guid) ? (
                                    <OwS3Uploader
                                        catalogGuid={this.state.catalogModel?.guid}
                                        resourceType={this.state.resourceType!}
                                        socket={this.props.socket}
                                        isReadOnly={false}
                                        userModel={this.props.userModel}
                                        supplierModel={this.props.supplierModel}
                                        isS3Upload={true}
                                        clearExistingForPriceGroups={this.state.clearExistingForPriceGroups}
                                    />
                                ) : this.state.upload_type === UploadTypeEnum.ITEM_IMAGE_URLS ? (
                                    <OwLabel title={"please_select_a_catalog"} />
                                ) : (
                                    <OwCsvReader onFileLoaded={this.csvLoaded} isProcessing={this.state.isProcessing} />
                                )}
                            </div>

                            <div>
                                {this.state.file ? (
                                    <div>
                                        <OwLabel title={"loaded_file"} noBottomMargin={true} isBold={true} isUnderline={true} />:{" "}
                                        {this.state.file.name}
                                    </div>
                                ) : null}
                                <div className={"d-flex justify-content-between error-section"}>
                                    <OwLabel
                                        className={"text-danger mt-2 " + (this.state.fileDropRejected ? "" : "d-none")}
                                        title={"file_drop_rejected_too_big"}
                                    />
                                    <OwLabel
                                        className={"text-danger mt-2 " + (this.state.fileTypeRejected ? "" : "d-none")}
                                        title={"file_type_invalid"}
                                    />
                                </div>
                            </div>
                        </div>
                    ) : null}

                    {this.state.showResults ? null : (
                        <div className={"mt-4 d-flex flex-column"}>
                            {this.state.upload_type === UploadTypeEnum.CATALOG_ITEM_UPDATE &&
                            this.props.supplierModel.has_auto_inactive_bulk_load ? (
                                <div>
                                    <OwCheckbox
                                        label={"set_inactive_nonpresent_items"}
                                        fn={this.handleChange}
                                        name={"performInactiveCheck"}
                                        falsyVal={false}
                                        truthyVal={true}
                                        checked={this.state.performInactiveCheck}
                                    />
                                </div>
                            ) : null}
                            {this.state.showBulkUploader || this.state.upload_type === UploadTypeEnum.CATALOG_ITEM_UPDATE ? (
                                <div>
                                    <OwLabel title={"please_wait_up_to_8_minutes_for_queue_to_process_check_email_for_report"} />
                                </div>
                            ) : (
                                <div>
                                    <OwButton
                                        title={"upload"}
                                        fn={this.doUpload}
                                        active={this.state.uploadActive}
                                        disabled={!this.state.isFormValid || this.state.uploadActive}
                                        disableOnActive={true}
                                    />
                                </div>
                            )}
                        </div>
                    )}
                </div>

                {this.state.showResults ? (
                    <div className={"mt-2"}>
                        <OwLabel title={"results"} noBottomMargin={true} />
                        <div>
                            <OwLabel title={"total_records"} noBottomMargin={true} className={"me-3"} isBold={true} />
                            {this.state.totalRecords}
                        </div>

                        <div>
                            <OwLabel title={"records_updated"} noBottomMargin={true} className={"me-3"} isBold={true} />
                            {this.state.recordsUpdated}
                        </div>

                        <div>
                            <OwLabel title={"records_created"} noBottomMargin={true} className={"me-3"} isBold={true} />
                            {this.state.recordsCreated}
                        </div>

                        <div>
                            <OwLabel title={"records_not_updated"} noBottomMargin={true} className={"me-3"} isBold={true} />
                            {this.state.recordsNotUpdated}
                        </div>

                        <div>
                            <OwLabel title={"records_errored"} noBottomMargin={true} className={"me-3"} isBold={true} />
                            {this.state.recordsErrored}
                        </div>
                    </div>
                ) : null}

                {this.state.uploadActive && this.state.bulkImageFile ? (
                    <div className={"w-100 mt-4"}>
                        <div className={""}>
                            <OwLabel title={"progress"} noBottomMargin={true} />
                            <OwProgressBar
                                showTitleChunk={true}
                                currentPercent={this.state.progressPerc}
                                titleChunkCurrent={this.state.progressChunk}
                                titleChunkTotal={this.state.progressTotal}
                            />
                        </div>
                    </div>
                ) : null}
            </div>
        );
    }
}

export default CatalogUploadUpdateModal;
